export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^.(,/\\{}[\]|<>):`"=+;_'?~&*-]{6,256}$/;

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
